const Divider = ({ children }) => (
	<div className="mb-3">
		{children}
	</div>
)

export default Divider